// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"b86384cf","395":"140b7097"}[chunkId] + ".chunk.css";
};